
define(['jquery', 'core', 'app-common/component/ajax-call'], function($, core, ajaxCall) {
  return function(resource, urlPart, type, data, dataType, contentType) {
    var url;
    if (dataType == null) {
      dataType = 'json';
    }
    if (contentType == null) {
      contentType = 'json';
    }
    url = core.getConfig().apiPrefix + resource + '.json/' + urlPart;
    return ajaxCall(url, type, data, dataType, false, false, contentType);
  };
});
